// @flow
import { getCreator } from '../../../http';
import environment from '../../../environment';
import { of } from 'rxjs';

export const endpoints = Object.freeze({
  SEARCH_PRODUCT: `${environment.apiUrl}/product-search`,
});

export const searchProductApi = getCreator(fetch, endpoints.SEARCH_PRODUCT);
/*export const searchProductApi = (queryOptions: any) => {
  console.log('queryOptions', queryOptions);
  return of(new Array(5).fill({
    name: 'Fox Mulder Fox Mulder Fox Mulder Fox Mulder Fox Mulder Fox Mulder Fox Mulder',
    image: 'https://pbs.twimg.com/media/CZmKlhsWQAEfAAp.jpg',
    price: '163',
    discount: '20'
  }));
};*/



// WEBPACK FOOTER //
// ./src/modules/new-order/SearchStep/api.js